import { render } from "./iconFacebook.vue?vue&type=template&id=3b096b0a&scoped=true"
import script from "./iconFacebook.vue?vue&type=script&lang=js"
export * from "./iconFacebook.vue?vue&type=script&lang=js"

import "./iconFacebook.vue?vue&type=style&index=0&id=3b096b0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b096b0a"

export default script